import * as React from 'react';
import { FormModal } from 'components/containers/FormModal';
import { CustomPublishingModalRow } from '../CustomPublishingModalRow';
import { ColoredCategory } from '../ColoredCategory';
import { GetCategoriesQuery } from 'models/graphql';
import { GetSocialProfiles_workspace_socialProfiles } from '../../../../models/legacy-graphql';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import { CategoriesState } from './ProfilePauseModal.controller';

export type ProfilePauseModalViewProps = {
  categories: GetCategoriesQuery['workspace']['categories'];
  profile: GetSocialProfiles_workspace_socialProfiles;
  onClose: VoidFunction;
  submitted: boolean;
  formInstance: UseFormReturn;
  onSubmit: SubmitHandler<CategoriesState>;
};

export const ProfilePauseModalView = (props: ProfilePauseModalViewProps): JSX.Element => {
  const categories = props.categories.map(
    (category: GetCategoriesQuery['workspace']['categories'][number], i: number) => {
      return (
        <CustomPublishingModalRow
          key={category.id}
          noBorder={props.categories.length - 1 === i}
          useFormInstance={props.formInstance}
          fieldName={`category-${category.id}`}>
          <ColoredCategory category={category} />
        </CustomPublishingModalRow>
      );
    }
  );
  return (
    <FormModal
      onClose={props.onClose}
      showCloseIcon={!props.submitted}
      formInstance={props.formInstance}
      loading={props.submitted}
      onSubmit={props.onSubmit}
      size={'large'}
      submitText={'Save Changes'}
      title={props.profile.displayName}>
      <p className={'margin-top-small-4'}>Pause specific Categories within this Profile, while keeping other Categories active.</p>
      {categories}
    </FormModal>
  );
};
